import { ReactNode } from "react";
import { createPortal } from "react-dom";

export const popoverOffsetY = 22;

export const portalDataAttr = "data-iframe-header-portal";

export function hasEmbeddedHeader() {
  return !!document.querySelector(`[${portalDataAttr}]`);
}

export function renderInEmbeddedHeader(element: ReactNode) {
  const portalTarget = document.querySelector(`[${portalDataAttr}]`);
  if (portalTarget) {
    return createPortal(element, portalTarget);
  }
}

export function getEmbeddedPortalDataAttr() {
  return { [portalDataAttr]: "true" };
}
